module.exports = global["HG_PPC_Maps"] = require("-!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/exports-loader/index.js?HG_PPC_Maps!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/babel-loader/lib/index.js??ref--0-0!./HG_get_quotes_ppc.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?HG_PPC_Maps!../node_modules/exports-loader?HG_PPC_Maps!../legacy/src/legacy/js/HG_get_quotes_ppc.js
// module id = 52
// module chunks = 1